import styled from "styled-components";

export const Divider = styled.hr`
  height: 1px;
  border-width: 0;
  background-color: ${({ theme }) => theme.COLORS.LightGray};
`;
